

function Why() {
    return (
        <div className="why-div">
            <h2 className="why-h2">Why Choose Blina?</h2>
            <ul className="why-ul">
                <li><b>Expert Team:</b> Our team of experienced professionals brings a wealth of knowledge and skill to every project.</li>
                <li><b>Personalized Service:</b> We take the time to understand your needs and preferences, ensuring that the final result is exactly what you envisioned.</li>
                <li><b>Proven Track Record:</b> With numerous successful projects and satisfied clients, we have a reputation for excellence in the industry.</li>
            </ul>
        </div>
    )
}

export default Why;